exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.iconsCell[data-v-7568b944] {\n  display: -ms-grid;\n  display: grid;\n  grid-gap: 5px;\n  /* Space between items */\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr 1fr 1fr;\n  /* Decide the number of columns and size */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7568b944","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/reservationLists/columns/icons.vue
// module id = 2708
// module chunks = 0